import { render, staticRenderFns } from "./wordsGraph.vue?vue&type=template&id=51044726&scoped=true&"
import script from "./wordsGraph.vue?vue&type=script&lang=js&"
export * from "./wordsGraph.vue?vue&type=script&lang=js&"
import style0 from "./wordsGraph.vue?vue&type=style&index=0&id=51044726&prod&lang=less&scoped=true&"
import style1 from "./wordsGraph.vue?vue&type=style&index=1&id=51044726&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51044726",
  null
  
)

export default component.exports